<prp-welcome-screen>
  <div class="error-content-container">
    <h3>{{ '404.title' | translate }}</h3>

    <p>{{ '404.message' | translate }}</p>

    <div class="d-flex mt-4">
      <button mat-raised-button color="primary" class="ms-auto" (click)="navigateBack()">
        {{ '404.button' | translate }}
      </button>
    </div>
  </div>
</prp-welcome-screen>
